import React, { useState } from "react";
import { askQuestion } from "../services/api";
import "../styles/AMA.css";

const AMA = () => {
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!question.trim()) return;

    setLoading(true);
    setError(null);

    try {
      const response = await askQuestion(question);
      setAnswer(response.answer);
    } catch (err) {
      console.error("Error submitting question:", err);
      const backendMessage =
        err?.response?.data?.answer || err?.response?.data?.error || null;
      setError(
        backendMessage || "Failed to get an answer. Please try again later."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    // Submit on Enter (but not when Shift+Enter is pressed for new lines)
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault(); // Prevent default to avoid adding a new line
      handleSubmit(e);
    }
  };

  return (
    <div className="ama-container">
      <div className="ama-profile">
        <img src="/profile.jpg" alt="Biel Casals" className="profile-image" />
        <h1>Ask Me Anything</h1>
        <p className="ama-intro">
          I'm Biel Casals, an MLOps Engineer. Ask me anything about my
          experience, projects, or expertise in machine learning operations!
        </p>
      </div>

      <div className="ama-chat">
        <form onSubmit={handleSubmit} className="question-form">
          <textarea
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="Ask me a question..."
            className="question-input"
            rows="4"
            disabled={loading}
          />
          <button
            type="submit"
            className="ask-button"
            disabled={loading || !question.trim()}
          >
            {loading ? "Thinking..." : "Ask Question"}
          </button>
        </form>

        {error && <div className="error-message">{error}</div>}

        {answer && (
          <div className="answer-container">
            <div className="answer-badge">Biel</div>
            <p className="answer-text">{answer}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AMA;
